import { Injectable } from '@angular/core';
import { JQueryHTTPClient } from './JQueryHTTPClient';
import { Rest } from './rest_client';

@Injectable({ providedIn: 'root' })
export class ReportBuilderService {
    private client: Rest.RestApplicationClient;

    constructor(private jquery: JQueryHTTPClient) {
        this.client = new Rest.RestApplicationClient(jquery);
    }

    findMine(): Rest.RestResponse<Rest.ReportBuilder[]> {
        return this.client.ReportBuilder_findMine();
    }

    save(definition: Rest.ReportBuilder): Rest.RestResponse<Rest.ReportBuilder> {
        return this.client.ReportBuilder_save(definition);
    }

    delete(id: number): Rest.RestResponse<void> {
        return this.client.ReportBuilder_delete(id);
    }

    generate(report: Rest.ReportBuilder): Rest.RestResponse<Rest.ReportBuilderQueryResult> {
        return this.client.ReportBuilder_generate(report);
    }
}
